module.exports = __webpack_public_path__ + "img/background_c3-2-1_mobile.20542d52.jpg";